import { getModuleLabelById } from "@xmiles/holopix-helper";
import { ModuleId } from "@xmiles/holopix-types";
import { CANVAS_DRAFT_FAMILY_IDS } from "@/constants/a3ModuleIds";

/**
 * 自由画布资产库场景筛选选项
 * UI顺序：两列布局，左列先从上到下，再右列从上到下
 */
export const canvasModuleOptions = [
  { label: "全部场景", value: null, divider: true },

  // 下面是画布的
  { label: getModuleLabelById(ModuleId.KleinFast), value: ModuleId.KleinFast },
  { label: getModuleLabelById(ModuleId.SeedDream), value: ModuleId.SeedDream },
  { label: getModuleLabelById(ModuleId.GptImage2), value: ModuleId.GptImage2 },
  { label: getModuleLabelById(ModuleId.GptImageV35), value: ModuleId.GptImageV35 },
  { label: getModuleLabelById(ModuleId.GptImageV35Flare), value: ModuleId.GptImageV35Flare },
  { label: getModuleLabelById(ModuleId.GptImage2Enterprise), value: ModuleId.GptImage2Enterprise },
  { label: getModuleLabelById(ModuleId.MonkeyV21), value: ModuleId.MonkeyV21 },
  { label: getModuleLabelById(ModuleId.Monkey), value: ModuleId.Monkey },

  // 35=CanvasComfyUISingle（ComfyUI 视频模板，module 恒为 35）、38=多输出模板、39=PSD 模板
  { label: "自由画布-智能模型", value: [ModuleId.CanvasComfyUISingle, ModuleId.CanvasComfyUIMulti, ModuleId.CanvasComfyUIPSD] },
  { label: getModuleLabelById(ModuleId.CanvasRender), value: ModuleId.CanvasRender },
  { label: getModuleLabelById(ModuleId.CanvasMatting), value: ModuleId.CanvasMatting },
  { label: getModuleLabelById(ModuleId.CanvasFission), value: ModuleId.CanvasFission },
  // 自由画布-一键成稿族：47 + A3 126
  { label: getModuleLabelById(ModuleId.CanvasDraft), value: [...CANVAS_DRAFT_FAMILY_IDS] },
  { label: getModuleLabelById(ModuleId.CanvasLocalRefine), value: ModuleId.CanvasLocalRefine },
  { label: getModuleLabelById(ModuleId.CanvasQwenFreePerspective), value: ModuleId.CanvasQwenFreePerspective },
  { label: getModuleLabelById(ModuleId.CanvasRepaintUpscale), value: ModuleId.CanvasRepaintUpscale },
  { label: getModuleLabelById(ModuleId.CanvasGenerate3d), value: ModuleId.CanvasGenerate3d },
  // 全能拆分（87）：拆分产物为图组记录，筛选后按组图卡片展示
  { label: getModuleLabelById(ModuleId.GameUiSplit), value: ModuleId.GameUiSplit },
  // 自由画布-智能扩图
  { label: getModuleLabelById(ModuleId.VisualExpansionV2), value: ModuleId.VisualExpansionV2 },

  // 自由画布-图生视频
  { label: "自由画布-图生视频", value: [ModuleId.CanvasImage2Video, ModuleId.SeedanceImage2Video, ModuleId.SeedanceMiniImage2Video, ModuleId.MinimaxH3Image2Video, ModuleId.MinimaxH3FastImage2Video, ModuleId.MinimaxH3MaxImage2Video] },
  // 自由画布-首尾帧生视频
  { label: "自由画布-首尾帧视频", value: [ModuleId.SeedanceStartEndVideo, ModuleId.CanvasStartEndVideo, ModuleId.SeedanceMiniStartEndVideo, ModuleId.MinimaxH3StartEndVideo, ModuleId.MinimaxH3FastStartEndVideo, ModuleId.MinimaxH3MaxStartEndVideo] },

  // 自由画布-文生视频
  { label: "自由画布-文生视频", value: [ModuleId.SeedanceText2Video, ModuleId.SeedanceMiniText2Video, ModuleId.MinimaxH3Text2Video, ModuleId.MinimaxH3FastText2Video, ModuleId.MinimaxH3MaxText2Video] },

  // 自由画布-多模态视频
  { label: "自由画布-多模态视频", value: [ModuleId.CanvasReferenceVideo, ModuleId.MinimaxH3ReferenceVideo, ModuleId.MinimaxH3FastReferenceVideo] },

  // 自由画布-全能参考
  { label: "自由画布-全能参考", value: [ModuleId.SeedanceReferenceVideo, ModuleId.SeedanceMiniReferenceVideo, ModuleId.MinimaxH3ReferenceVideo, ModuleId.MinimaxH3FastReferenceVideo] },
  { label: getModuleLabelById(ModuleId.CanvasSeedreamV5Pro), value: ModuleId.CanvasSeedreamV5Pro },

  // 悠船只展示一套名称。筛选项同时覆盖阿里云新通道与旧通道，避免菜单重复且旧作品仍能筛到
  { label: "Midjourney V8.2", value: [ModuleId.AliyunYouchuanV82Fastest, ModuleId.MidjourneyV82] },
  { label: "Midjourney V7", value: [ModuleId.AliyunYouchuan, ModuleId.Midjourney] },
  { label: "Midjourney Niji7", value: [ModuleId.AliyunYouchuanNiji7, ModuleId.MidjourneyNiji7] },
  { label: "Midjourney V8.1", value: [ModuleId.AliyunYouchuanV81, ModuleId.MidjourneyV81] },
];
